declare global {
  interface Window {
    // add you custom properties and methods
    __env: object;
  }
}

const browserWindow = window || {};
const appSettings: any = browserWindow.__env || {};

export function getOauthCodeFlowSettings() {
  return appSettings.OAUTH_CODE_FLOW_SETTINGS;
}

export function getAppApiUrl() {
  return appSettings.APP_API_URL;
}

export function getApiMockEnabled() {
  return appSettings.API_MOCK_ENABLED;
}

export function getAppMapping() {
  return appSettings.appsMapping;
}

export function APP_RECAPTCHA_SITEKEY() {
  return appSettings.APP_RECAPTCHA_SITEKEY;
}

export function mode() {
  return appSettings.mode;
}

export function getGTAG() {
  return appSettings.GTAG;
}

export function getExternalLinks() {
  return appSettings.externalLinks;
}

export function GOOGLE_API_KEY() {
  return appSettings.GOOGLE_API_KEY;
}